import { NOTIFICATIONS_CONSTANTS } from '../constants/NotificationsConstants';

const AUTOMATIC_CARD_NOTIFICATIONS = {
    AD_CREATION: gettext('Congratulations! You just started a new ad experiment!'),
    AD_EXPERIMENTS: gettext('Congratulations! You just paused the underperforming ad version and increased average results by'),
    ADS_IN_EXCESS: gettext('Congratulations! You just improve your performance by'),
    ADS_WITH_OVER_DAYS: gettext('Congratulations! You just paused an ad and improved your performance.'),
    BAD_PLACEMENT_SITE_PERFORMANCE_FINAL: gettext('of your potential spent!'),
    BAD_PLACEMENT_SITE_PERFORMANCE_INITIAL: gettext('Congratulations! You just saved'),
    BRAND_DAMAGE_ALERT: gettext('Congratulations! You just exclude damages website categories!'),
    DEFAULT_NOTIFICATION: gettext("Congratulations! It's done!"),
    DISPLAY_FRAUD_FINDER_FINAL: gettext('annually!'),
    DISPLAY_FRAUD_FINDER_INITIAL: gettext('Congratulations! You just saved up to'),
    FACEBOOK_CREATIVE_EXPERIMENT: gettext('Congratulations! You just paused a underperforming creative and increase performance by'),
    SEARCH_TERM_SUGGESTIONS: gettext('Congratulations! You just saved'),
    SMART_FUNNEL_CAMPAIGN: gettext('Congratulations! You just adjusted your campaign budget and improved your overall performance by'),
    TEMPLATE_BID_MODIFIER_AGE_FINAL: gettext('and improved your performance.'),
    TEMPLATE_BID_MODIFIER_AGE_INITIAL: gettext('Congratulations! You just adjust your campaign age bid by'),
    TEMPLATE_BID_MODIFIER_DEVICE_FINAL: gettext('and improved your performance.'),
    TEMPLATE_BID_MODIFIER_DEVICE_INITIAL: gettext('Congratulations! You just adjust your campaign device bid by'),
    TEMPLATE_BID_MODIFIER_GENDER_FINAL: gettext('and improved your performance.'),
    TEMPLATE_BID_MODIFIER_GENDER_INITIAL: gettext('Congratulations! You just adjust your campaign gender bid by'),
};

const MANUAL_CARD_NOTIFICATIONS = {
    DUPLICATING: gettext('Duplicating the Card...'),
    SUCCESSFULLY_DUPLICATED: gettext('Card successfully duplicated!'),
    ERROR: gettext(NOTIFICATIONS_CONSTANTS.ERROR),
    MINIMUM_ASSIGNEES: gettext('Card needs at least one assignee!'),
};

const FILE_UPLOADER_NOTIFICATIONS = {
    UPLOADING: gettext('Uploading the file...'),
    SUCCESSFUL: gettext('File successfully uploaded!'),
    ERROR: gettext('An error occurred while uploading the file'),
};

const ACCOUNT_NOTIFICATIONS = {
    MOCKED_ACCOUNT_WARNING: gettext('The data in this page is not real. Please link an Ad Account to see real data.'),
};

const MANAGE_SETTINGS_NOTIFICATIONS = {
    EDIT_ACCOUNT: {
        SUCCESSFUL: gettext('Account successfully edited!'),
        ERROR: gettext('Oops, something went wrong!'),
    },
    EDIT_GOAL: {
        SUCCESSFUL: gettext('Goal successfully saved!'),
        ERROR: gettext('Oops, something went wrong!'),
        WARNING: gettext('This goal will be deactivated on '),
    },
    CREATE_GOAL: {
        SUCCESSFUL: gettext('Goal successfully created!'),
        ERROR: gettext('Oops, something went wrong!'),
    },
};

const SEGMENTED_CONTEXT_NOTIFICATIONS = {
    UPDATE_HOTSPOT: {
        SUCCESSFUL: gettext('Hotspot updated sucessfully!'),
        ERROR: gettext('An error occurred while updating hotspot'),
    },
    SELECT_METRICS: {
        ERROR: gettext('At least one metric needs to be selected.'),
    },
    ANALYTICS_ACCOUNT_NOT_FOUND_ERROR: gettext('Google Analytics is missing. Please link it here.'),
    NO_DATA_FOR_ACCOUNT: gettext('No Data for Account: '),
    GET_REPORT: {
        ERROR: gettext('Something went wrong. Please contact support.'),
        ID: 1,
    },
    ANALYTICS_ACCOUNT_VIEW_NOT_FOUND_ERROR: gettext('Google Analytics View is missing. Please link it here.'),
    ANALYTICS_ACCOUNT_GOAL_NOT_FOUND_ERROR: gettext('Please do a Google Analytics integration again to view your goals.'),
    NO_GOOGLE_ANALYTICS_REFRESH_TOKEN_ERROR: gettext('No Google Analytics Integration found. Click here to Integrate.'),
};

const BANNER_FACTORY_NOTIFICATIONS = {
    UPLOAD: {
        IMAGE: {
            SUCCESSFUL: gettext('Image uploaded successfully!'),
            ERROR: gettext('An error occurred while uploading your image.'),
        },
        VIDEO: {
            SUCCESSFUL: gettext('Video uploaded successfully!'),
            ERROR: gettext('An error occurred while uploading your video.'),
        },
    },
};

export {
    AUTOMATIC_CARD_NOTIFICATIONS,
    MANUAL_CARD_NOTIFICATIONS,
    FILE_UPLOADER_NOTIFICATIONS,
    ACCOUNT_NOTIFICATIONS,
    MANAGE_SETTINGS_NOTIFICATIONS,
    SEGMENTED_CONTEXT_NOTIFICATIONS,
    BANNER_FACTORY_NOTIFICATIONS,
};
